import Layout from '@/layout';
var dealerRouter = {
  path: '/dealer',
  component: Layout,
  redirect: '/dealer/index',
  name: 'Dealer',
  alwaysShow: true,
  meta: {
    title: '经销商',
    icon: 'clipboard'
  },
  children: [{
    path: 'setting',
    component: function component() {
      return import('@/views/dealer/setting/index');
    },
    name: 'DealerSetting',
    meta: {
      title: '招商设置'
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/dealer/level/index');
    },
    name: 'DealerLevel',
    meta: {
      title: '招商等级'
    }
  }, {
    path: 'level/edit/:id?/:levelType?',
    component: function component() {
      return import('@/views/dealer/level/edit');
    },
    name: 'DealerLevelEdit',
    hidden: true,
    meta: {
      title: '添加招商等级',
      activeMenu: '/dealer/level',
      noCache: true
    }
  }, {
    path: 'list',
    component: function component() {
      return import('@/views/dealer/list');
    },
    name: 'DealerIndex',
    meta: {
      title: '招商人员'
    }
  }, {
    path: 'dividend',
    component: function component() {
      return import('@/views/dealer/dividend/index');
    },
    name: 'DealerDividend',
    meta: {
      title: '招商分红'
    }
  }, {
    path: 'shareholder/setting',
    component: function component() {
      return import('@/views/dealer/shareholder/setting/index');
    },
    name: 'ShareholderSetting',
    meta: {
      title: '股东分红设置'
    }
  }, {
    path: 'shareholder/record',
    component: function component() {
      return import('@/views/dealer/shareholder/record/index');
    },
    name: 'ShareholderRecord',
    meta: {
      title: '股东分红记录'
    }
  }, {
    path: 'shareholder/expected',
    component: function component() {
      return import('@/views/dealer/shareholder/expected/index');
    },
    name: 'ShareholderExpected',
    meta: {
      title: '当前周期预计分红'
    }
  }]
};
export default dealerRouter;